import React, { useContext, useEffect, useState } from 'react';

import { Box } from '@material-ui/core';

import ScreenTextContext from '../../contexts/ScreenTextContext';
import { Callout } from '../Callout';
import { CtaButton } from '../';
import { RadioToggle } from '.';


const languages = ["en", "es"];

export const ChooseLanguage = ({changeStep}) => {
  
  // Load screen text
  const { screenText, getScreenText } = useContext(ScreenTextContext);  
  const {language, setUp : setUpScreenText} = screenText;
  
  const [selectedLanguage, setSelectedLanguage] = useState(language || languages[0]);
  

  useEffect(() => {
    getScreenText(selectedLanguage)
  }, [selectedLanguage, getScreenText])

  const handleClick = () => {
    changeStep.forward();
  }

  if (!setUpScreenText) {
    return ''; // Should return error? Loading?
  }

  return (
    <div className="lang page-container">

      <div className="set-up__container set-up__container--outlined ">

        <h1 className="lang__title">{setUpScreenText.language.title}</h1>

        <p className="lang__subtitle">{setUpScreenText.language.subtitle}</p>
        <p className="lang__description">{setUpScreenText.language.description}</p>

        <RadioToggle
          hideLabel={true}
          label={setUpScreenText.language.label}
          name="language"
          setValue={setSelectedLanguage}
          value={selectedLanguage}
          options={languages.map(lang => ({
            value: lang,
            label: setUpScreenText.language[lang]
          }))}
        />

      </div>

      <div className="lang__btn-footer">
        <Box display="flex" >
          <Callout>{setUpScreenText.language.calloutText}</Callout>
        </Box>
        
        <Box display="flex" justifyContent="center">
          <CtaButton onClick={handleClick}>
            {setUpScreenText.language.ctaButton}
          </CtaButton>
        </Box>

        <div className="spacer"></div>
  
      </div>

      <div className="flex flex-row position-relative w-100 justify-content-center align-items-center">
        <div className="set-up__disclaimer">{setUpScreenText.language.disclaimer}</div>
      </div>

    </div>
  )
}